window.initUniversalRoll = function initUniversalRoll() {
  const elements = document.querySelectorAll('[data-roll]');

  elements.forEach((el) => {
    if (el.classList.contains('is-init-roll')) return;
    el.classList.add('is-init-roll');

    const styles = window.getComputedStyle(el);
    const elementDisplay = ['inline', 'inline-block', 'none'].includes(styles.display) ? 'flex' : styles.display;
    const layoutProps = {
      display: elementDisplay,
      justifyContent: styles.justifyContent,
      alignItems: styles.alignItems,
      gap: styles.gap,
    };

    const original = document.createElement('span');
    original.classList.add('roll__original');

    Object.assign(original.style, layoutProps);

    while (el.firstChild) {
      original.appendChild(el.firstChild);
    }

    const hover = original.cloneNode(true);
    hover.classList.remove('roll__original');
    hover.classList.add('roll__hover');
    hover.setAttribute('aria-hidden', 'true');

    el.appendChild(original);
    el.appendChild(hover);
  });
};

initUniversalRoll();
